import router, { constantRoutes } from "@/router";

// import Layout from "@/layout";

export function generateAsyncRoutes(menus) {
  // console.log(menus)
  const res = [];

  menus.forEach((menu) => {
    if (menu.component && menu.path) {
      const tmp = {
        path: menu.path,
        component:
          menu.component == "/layout"
            ?  () => import("@/layout/index.vue")
            : () => import("@/views" + menu.component + ".vue"),
        name: menu.name,
        meta: menu.meta,
      };

      if (menu.children) {
        tmp.children = generateAsyncRoutes(menu.children);
      }

      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [], //当前用户的路由地址
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes; //添加的路由
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, menus) {
    return new Promise((resolve) => {
      let accessedRoutes;
      accessedRoutes = generateAsyncRoutes(menus);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
